import { NgForOf } from '@angular/common'
import { Directive, Host, Input } from '@angular/core'

/**
 * Pipe to avoid unnecessary re-rendering of list items
 * *ngFor="let profile of profiles; trackByProperty: 'uuid'"
 */
@Directive({
  selector: '[ngForTrackByProperty]',
})
export class TrackByPropertyDirective {
  private _propertyName: string = ''

  @Input('ngForTrackByProperty')
  set propertyName(value: string | null) {
    this._propertyName = value || ''
  }

  constructor(@Host() private readonly ngFor: NgForOf<any>) {
    this.ngFor.ngForTrackBy = (index: number, item: any) => (this._propertyName ? item[this._propertyName] : item)
  }
}
